export const REGISTRATION_STATES = {
  SUCCESS: 'success',
  COMPANIES_SEARCH: 'companies_search',
  ACTIVITY_NOT_ALLOWED: 'activity_not_allowed',
  USER_PHONE_NUMBER: 'user_phone_number',
  COMPANY_INFO: 'company_info',
  COMPANY_REGISTRATION_DOCUMENTS: 'company_registration_documents',
  MANAGEMENT_TYPE: 'management_type',
  PARTNERSHIP_AGREEMENT: 'partnership_agreement',
  COMPANY_ADDRESS: 'company_address',
  BUSINESS_ACTIVITY_ENTITY_TYPE: 'business_activity_entity_type',
  COMPANY_FINANCES: 'company_finances',
  BYLAW_OCR: 'bylaw_ocr',
  EARLY_BYLAW_SELECTION: 'early_bylaw_selection',
  COMPANY_ACTIVITY: 'company_activity',
  OWNER_SELECT: 'owner_select',
  OWNER_INFO: 'owner_info',
  OWNER_ADDITIONAL_INFO: 'owner_additional_info',
  OWNER_FINANCIAL_INFO: 'owner_financial_info',
  LEGAL_REPRESENTATIVES_INFO: 'legal_representatives_info',
  OWNER_PHONE_NUMBER: 'owner_phone_number',
  OWNER_ADDRESS: 'owner_address',
  OWNER_POI: 'owner_poi',
  OWNER_POWER_GIVER: 'power_giver',
  OWNER_INVOICE_DETAILS: 'owner_invoice_details',
  DECLARED_PEP_IN_BENEFICIARIES: 'declared_pep_in_beneficiaries',
  COMPANY_BENEFICIARIES: 'company_beneficiaries',
  COMPANY_NATURE_OF_OPS: 'nature_of_ops',
  COMPANY_PRICE_PLAN_SELECTION: 'price_plan_selection',
  COMPANY_PAYMENT: 'payment',
  COMPANY_PAYMENT_SUCCESS: 'payment_success',
  COMPANY_CONTRACT: 'contract',
  COMPANY_SIGNING_CONTRACT: 'signing_contract',
  COMPANY_PENDING_CONTRACT_SIGN: 'pending_contract_sign',
  COMPANY_CONTRACT_SIGNED: 'contract_signed',
  COMPANY_LEGAL_REGISTRATION_INFO: 'company_legal_registration_info',
  HANDOVER_TO_PARTNER: 'handover_to_partner',
  LANDING_FROM_PARTNER: 'landing_from_partner',
  COMPANY_TENURE: 'company_tenure',
  LEGAL_FORM_GROUP: 'legal_form_group',
  DECLARED_NUMBER_OF_EMPLOYEES: 'declared_number_of_employees',
  ACCOUNTANT: 'accountant',
  CROSS_SELL_OFFERS: 'cross_sell_offers',
  LEGAL_FORM: 'legal_form',
  TAX_NUMBER: 'tax_number',
  COMPANY_CREATION_TYPE: 'company_creation_type',
  NOTARY_PACKAGE_SELECTION: 'notary_package_selection',
  NOTARY_EXTERNAL_FORM: 'notary_external_form',
  NOTARY_INCORPORATION_PENDING: 'notary_incorporation_pending',
  REGISTRATION_UNAVAILABLE: 'registration_unavailable',
} as const;

export type RegistrationState = (typeof REGISTRATION_STATES)[keyof typeof REGISTRATION_STATES];
